import abi from './abi.json';
import { Network } from '../../providers/Networks/useNetworks';
import { IContractConfig } from '../types';

export const hashConfig: { [network in Network]: IContractConfig } = {
	[Network.MUMBAI_TESTNET]: {
		abi,
		address: '0x6388087689F441B63f7A80A6555c905B8Fd53f37',
	},
	[Network.POLYGON_MAINNET]: {
		abi,
		address: '0x6388087689F441B63f7A80A6555c905B8Fd53f37',
	},
};
